import { Component, ElementRef, OnInit, VERSION, ViewChild, forwardRef, ChangeDetectorRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule, NG_VALUE_ACCESSOR, FormGroupDirective } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
// import { LoginService } from '../../services/login/login.service';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { BsDatepickerConfig, BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { ToastrService } from 'ngx-toastr';
// import { Authenticate } from '../../models/authenticate';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NavMenu } from '../nav-menu/nav-menu'


@Component({
  selector: 'app-agri',
  templateUrl: './agri.html',
  styleUrls: ['./agri.css'],
  imports: [NavMenu, RouterLink, RouterLinkActive, RouterModule, ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule, MatStepperModule, BsDatepickerModule],
})
export class AgriStats {
  isExpanded = false;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
